(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8688],{

/***/ 21305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var BrandingLogos = function BrandingLogos(_ref) {
  var heading = _ref.heading,
      footing = _ref.footing,
      headingSize = _ref.headingSize,
      isEngineer = _ref.isEngineer;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2
      }
    }]
  };
  var logoWidth = 300;
  var logoHeight = 105;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: "my-7",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: "mb-4 font-semibold text-md text-[#7D7D7D] text-center items-center ".concat(headingSize || ""),
      children: heading || "Trusted by"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: "brand-logo-carousel",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_slick__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, settings), {}, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/vts-logo.svg",
            alt: "vts-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/zillow-logo.svg",
            alt: "zillow-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/medikabazaar-logo.svg",
            alt: "medikabazaar-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/alhabtoor-logo.svg",
            alt: "alhabtoor-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/medicines_patent_pool-logo.svg",
            alt: "medicines_patent_pool-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/klub-logo.svg",
            alt: "klub-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/instarem.-logo.svg",
            alt: "instarem.-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/highnote-logo.svg",
            alt: "highnote-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/buildly-logo.svg",
            alt: "buildly-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/jll-logo.svg",
            alt: "jll-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: logoWidth,
            height: logoHeight,
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/visa-logo.svg",
            alt: "visa-logo",
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: "mt-3",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
            width: "250",
            height: "55",
            layout: "responsive",
            className: "mx-auto",
            src: "/logos/cpx-logo.svg",
            alt: "cpx-logo",
            loading: "lazy"
          })
        })]
      }))
    }), footing && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: "mt-4 text-center text-md text-[#7D7D7D]",
      children: footing
    }), !["/", "/companies", "/businesses"].includes(router === null || router === void 0 ? void 0 : router.pathname) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: "mx-auto max-w-7xl px-4 pt-6 -pb-8 sm:px-6 lg:px-8 relative",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: "mx-auto max-w-lg text-center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
          href: "".concat(isEngineer || router !== null && router !== void 0 && router.pathname.includes("/about") ? "/signup" : "/demo"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
            className: "".concat(isEngineer || router !== null && router !== void 0 && router.pathname.includes("/about") ? "bg-primary-600" : "bg-red-400", " group inline-flex items-center justify-center rounded-full py-3 px-8 text-lg mb-10 font-semibold mt-10 text-white hover:bg-primary-700"),
            "data-test-id": "get-started-today",
            target: "_blank",
            children: isEngineer || router !== null && router !== void 0 && router.pathname.includes("/about") ? "Interview Now" : "Book a demo"
          })
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BrandingLogos);

/***/ }),

/***/ 32737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nt": function() { return /* binding */ InfoSectionFeatures; },
/* harmony export */   "aB": function() { return /* binding */ FAQSectionText; },
/* harmony export */   "b7": function() { return /* binding */ FAQAccordion; },
/* harmony export */   "gI": function() { return /* binding */ ReviewSection; },
/* harmony export */   "vE": function() { return /* binding */ IntegrationsOffered; }
/* harmony export */ });
/* unused harmony export QualitiesTriangle */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27812);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46066);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_layouts_CImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79841);
/* harmony import */ var _data_staticContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23701);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var FAQAccordion = function FAQAccordion(_ref) {
  var items = _ref.items;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var toggle = function toggle(index) {
    if (isOpen === index) {
      setIsOpen(null);
    } else {
      setIsOpen(index);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
    className: "w-full space-y-1",
    children: items.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "w-full bg-white",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: "flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0 md:space-x-4",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "w-full",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
              className: "flex justify-between items-center py-4 px-8 cursor-pointer shadow-sm",
              onClick: function onClick() {
                return toggle(index);
              },
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("span", {
                className: "flex space-x-4 font-display text-xl tracking-tight text-gray-500",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  children: "\u2022"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h3", {
                  children: item.title
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                className: "h-3 ".concat(index !== isOpen && "-rotate-90"),
                src: "/home/chevron-down.svg",
                alt: "chevron-down",
                loading: "lazy",
                width: 14,
                height: 14
              })]
            }), isOpen === index && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
              className: "px-8 py-4 flex space-x-6",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                className: "opacity-0",
                children: "\u2022"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
                className: "text-gray-400  whitespace-pre-line",
                dangerouslySetInnerHTML: {
                  __html: item.description
                }
              })]
            })]
          })
        })
      }, index);
    })
  });
};
var QualitiesTriangle = function QualitiesTriangle(_ref2) {
  var _qualities$, _qualities$2, _qualities$3, _qualities$4, _qualities$5, _qualities$6;

  var qualities = _ref2.qualities,
      time = _ref2.time;

  var _useState2 = useState(qualities[0]),
      currentQuality = _useState2[0],
      setCurrentQuality = _useState2[1];

  var timeOutRef = useRef(null);
  useEffect(function () {
    timeOutRef.current = setTimeout(function () {
      var index = qualities.findIndex(function (quality) {
        return quality.title === currentQuality.title;
      });

      if (index === qualities.length - 1) {
        setCurrentQuality(qualities[0]);
      } else {
        setCurrentQuality(qualities[index + 1]);
      }
    }, time || 3000);
    return function () {
      clearTimeout(timeOutRef.current);
    };
  }, [currentQuality]);
  return /*#__PURE__*/_jsxs("section", {
    className: "bg-ellipse px-10  sm:pb-16 pt-16 sm:px-0 max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-[3fr_4fr_3fr] lg:grid-cols-[1fr_500px_1fr] justify-center",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "hidden sm:flex flex-col space-y-2",
      children: [/*#__PURE__*/_jsx("div", {
        className: "grow"
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h3", {
          className: "text-2xl font-semibold text-center pb-4",
          children: (_qualities$ = qualities[0]) === null || _qualities$ === void 0 ? void 0 : _qualities$.title
        }), /*#__PURE__*/_jsx("p", {
          className: "text-center",
          children: (_qualities$2 = qualities[0]) === null || _qualities$2 === void 0 ? void 0 : _qualities$2.description
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "hidden sm:flex text-center space-y-2 justify-center flex-col min-h-[150px] max-h-[150px]",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "text-2xl font-semibold pb-4",
          children: (_qualities$3 = qualities[1]) === null || _qualities$3 === void 0 ? void 0 : _qualities$3.title
        }), /*#__PURE__*/_jsx("p", {
          children: (_qualities$4 = qualities[1]) === null || _qualities$4 === void 0 ? void 0 : _qualities$4.description
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "static sm:hidden text-center space-y-2 min-h-[180px] max-h-[180px]",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "text-2xl font-semibold pb-4",
          children: currentQuality === null || currentQuality === void 0 ? void 0 : currentQuality.title
        }), /*#__PURE__*/_jsx("p", {
          children: currentQuality === null || currentQuality === void 0 ? void 0 : currentQuality.description
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "aspect-square w-full relative",
        children: [/*#__PURE__*/_jsx(Image, {
          src: "/home/qualities-triangle.svg",
          className: "opacity-100 sm:opacity-0 absolute top-4 left-0 right-0 bottom-0 z-10 rotating-triangle",
          style: {
            animationDuration: "".concat(time * 3 || 9000, "ms")
          }
        }), /*#__PURE__*/_jsx(Image, {
          src: "/home/qualities-triangle.svg",
          className: "hidden sm:block w-full scale-110 translate-y-[10%]"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "hidden sm:flex flex-col",
      children: [/*#__PURE__*/_jsx("div", {
        className: "grow"
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-end",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "text-2xl font-semibold text-center pb-4",
          children: (_qualities$5 = qualities[2]) === null || _qualities$5 === void 0 ? void 0 : _qualities$5.title
        }), /*#__PURE__*/_jsx("p", {
          className: "text-center",
          children: (_qualities$6 = qualities[2]) === null || _qualities$6 === void 0 ? void 0 : _qualities$6.description
        })]
      })]
    })]
  });
};
var InfoSectionFeatures = function InfoSectionFeatures(_ref3) {
  var infoSections = _ref3.infoSections;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("section", {
    className: "mt-16",
    children: infoSections.map(function (section, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: "flex flex-col md:flex-row ".concat(index % 2 === 1 && "md:flex-row-reverse"),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: "w-full md:w-1/2 min-h-[500px] flex items-center justify-center bg-[#CFF5FE] bg-opacity-[0.15]",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "w-3/4",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h2", {
              className: "font-display text-2xl tracking-tight text-slate-900 sm:text-3xl whitespace-pre-line\t",
              "data-test-id": "info-title-".concat(index),
              children: section.title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
              className: "mt-6 text-xl text-gray-500 mx-auto max-w-3xl ",
              "data-test-id": "info-description-".concat(index),
              children: section.description
            })]
          })
        }), section.hero && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: "w-full md:w-1/2  self-stretch min-h-[300px] flex items-center justify-center relative",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(section.hero, {})
        }), section.heroImg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: "w-full md:w-1/2  self-stretch min-h-[300px] flex items-center justify-center relative",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
            src: section === null || section === void 0 ? void 0 : section.heroImg,
            srcSet: section.heroImg2 && section.heroImg2.concat(" 2x"),
            alt: "hero image",
            layout: "fill",
            objectFit: "contain"
          })
        })]
      }, index);
    })
  });
};
var ReviewSection = function ReviewSection(_ref4) {
  var heading = _ref4.heading,
      description = _ref4.description;
  var content = _data_staticContent__WEBPACK_IMPORTED_MODULE_7__/* .staticContent.candidateReviews */ .e.candidateReviews;

  var ReviewCard = function ReviewCard(_ref5) {
    var name = _ref5.name,
        rating = _ref5.rating,
        desc = _ref5.desc,
        img = _ref5.img,
        index = _ref5.index;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "flex flex-col items-center pt-20 ".concat(index === 1 || index === 3 ? "scale-105 -translate-y-[5%]" : "scale-95"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: "relative mx-10 rounded-t-xl bg-white",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_layouts_CImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          src: "/logos/Star-9.svg",
          height: "185",
          width: "195",
          className: "ml-auto mr-0 w-1/3 h-1/3 translate-x-[33%] -mt-[50px]",
          alt: "start",
          loading: "lazy"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "px-8 mb-16 relative",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_layouts_CImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            height: "29",
            width: "22",
            src: "/logos/quote.svg",
            alt: "quote",
            className: "mb-2 absolute top-0 -translate-y-[150%] -translate-x-1/2",
            loading: "lazy"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h3", {
            className: "text-lg h-[80px]",
            children: desc
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "mx-4 flex space-x-4 py-4 px-8 justify-between items-center bg-[#FAFAFA] rounded-b-xl",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_layouts_CImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            src: img,
            alt: name,
            className: "w-16 h-16",
            imgclassname: "rounded-full",
            width: 64,
            height: 64
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "text-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
              className: "flex items-center space-x-2",
              children: [(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Array(Math.floor(rating))).map(function (_, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                  src: "/logos/star-sm.svg",
                  alt: "star",
                  width: 20,
                  height: 20
                }, index);
              }), rating % 1 !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                height: 25,
                width: 25,
                src: "/logos/star-sm.svg",
                alt: "star",
                style: {
                  clipPath: "polygon(0 0, 50% 0, 50% 100%, 0% 100%)"
                },
                loading: "lazy"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h4", {
              className: "font-bold text-lg mt-2",
              children: name
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {})]
        })
      })]
    });
  };

  var reviews = [{
    name: "Sumit S",
    rating: 5,
    desc: "The interview was challenging and interesting. It's highly engaging.",
    img: "/logos/profile.svg"
  }, {
    name: "Priyanka C",
    rating: 5,
    desc: "This was the first time that the interviewer made things so clear and explained everything. Thanks Tacnique.",
    img: "/logos/profile.svg"
  }, {
    name: "Ankita R",
    rating: 4.5,
    desc: "It was a great interview session. The process was easy and smooth.",
    img: "/logos/profile.svg"
  }, {
    name: "Arnab D",
    rating: 5,
    desc: "Really liked it and learnt a lot. Highly recommended.",
    img: "/logos/profile.svg"
  }, {
    name: "Seema S",
    rating: 4.5,
    desc: "Good experience to have such wonderful discussion and getting instant feedbacks.",
    img: "/logos/profile.svg"
  }];
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("section", {
    className: "pt-24",
    id: "responsive-section",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "flex flex-col items-center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h2", {
        className: "font-display text-3xl tracking-tight text-slate-900 sm:text-4xl font-bold",
        children: heading || "Testimonials From Engineers Speak Volumes"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
        className: "mt-6 text-xl text-center mx-auto max-w-3xl tracking-tight text-gray-500",
        children: description || "Tacnique is the clear choice for job seekers who want to land their dream job. Join the happy Tacnique family today!"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "py-16",
      style: {
        //linear gradient white to 50% primary color
        background: "linear-gradient(180deg, transparent 0%, transparent 50%, #0E7783 50%,#0E7783 100%)"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_slick__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, settings), {}, {
        children: [reviews.map(function (review, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ReviewCard, _objectSpread(_objectSpread({}, review), {}, {
            index: index
          }), index);
        }), content === null || content === void 0 ? void 0 : content.map(function (review, index) {
          var _review$userImage, _review$userImage$fie, _review$userImage$fie2, _review$userImage2, _review$userImage2$fi, _review$userImage2$fi2;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ReviewCard, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, review), {}, {
            rating: parseInt(review.ratings || 0),
            desc: review.description,
            img: review !== null && review !== void 0 && (_review$userImage = review.userImage) !== null && _review$userImage !== void 0 && (_review$userImage$fie = _review$userImage.fields) !== null && _review$userImage$fie !== void 0 && (_review$userImage$fie2 = _review$userImage$fie.file) !== null && _review$userImage$fie2 !== void 0 && _review$userImage$fie2.url ? 'https:' + (review === null || review === void 0 ? void 0 : (_review$userImage2 = review.userImage) === null || _review$userImage2 === void 0 ? void 0 : (_review$userImage2$fi = _review$userImage2.fields) === null || _review$userImage2$fi === void 0 ? void 0 : (_review$userImage2$fi2 = _review$userImage2$fi.file) === null || _review$userImage2$fi2 === void 0 ? void 0 : _review$userImage2$fi2.url) : "/loading-placeholder.png"
          })), {}, {
            index: index
          }), index);
        })]
      }))
    })]
  });
};
var FAQSectionText = function FAQSectionText(_ref6) {
  var description = _ref6.description,
      isEngineer = _ref6.isEngineer;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "mx-auto max-w-lg text-center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: "".concat(isEngineer || router !== null && router !== void 0 && router.pathname.includes("/about") ? "/signup" : "/demo"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
            className: "".concat(isEngineer ? "bg-primary-600" : "bg-red-400", " group inline-flex items-center justify-center rounded-full py-3 px-8 text-lg mb-10 font-semibold mt-10 text-white hover:bg-primary-700"),
            "data-test-id": "get-started-today",
            target: "_blank",
            children: isEngineer ? "Interview Now" : "Book a demo today"
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "space-y-4 text-center mb-12",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h2", {
        className: "font-display text-3xl tracking-tight text-slate-900 sm:text-4xl font-bold",
        children: "Frequently Asked Questions"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
        children: description || "Get quick and reliable answers to your questions on our cloud interview platform, candidate assessment, recruitment best practices, and more."
      })]
    })]
  });
};
var IntegrationsOffered = function IntegrationsOffered(_ref7) {
  var heading = _ref7.heading,
      description = _ref7.description;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("section", {
    id: "secondary-features",
    "aria-label": "Features for simplifying everyday business tasks",
    className: "pt-20 integration-container",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: "mx-auto  md:text-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h2", {
          className: "font-display text-3xl tracking-tight text-slate-900 sm:text-4xl font-bold",
          "data-test-id": "interview-title",
          children: heading || "Integrations we offer"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
          className: "mt-6 text-xl mx-auto max-w-3xl tracking-tight text-gray-500",
          "data-test-id": "interview-description",
          children: description || "Worried about your ATS integrations? With Tacnique's custom ATS integrations, there's no need to change the way you operate."
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "mt-10 mx-auto  overflow-x-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: "min-w-[700px]",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
            src: "/logos/integration/integrations.png",
            alt: "integrations",
            layout: "responsive",
            width: 1200,
            height: 500
          })
        })
      })]
    })
  });
};

/***/ }),

/***/ 38688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ HeroSection; },
  "Z": function() { return /* binding */ home_Home; }
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-modal-video/lib/index.js
var lib = __webpack_require__(61239);
// EXTERNAL MODULE: ./node_modules/react-type-animation/dist/esm/index.es.js
var index_es = __webpack_require__(9844);
// EXTERNAL MODULE: ./src/css/modules/headerNav.module.scss
var headerNav_module = __webpack_require__(18556);
var headerNav_module_default = /*#__PURE__*/__webpack_require__.n(headerNav_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/commonlayout/HeaderNav.js









var HeaderNav = function HeaderNav() {
  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "relative overflow-hidden first-fold-image",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "max-w-7xl mx-auto",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "lg:mt-48 mt-40 md:mt-40 relative z-10 lg:w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
          className: "mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-24 lg:mt-20 lg:px-8 xl:mt-24",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center items-center font-sans",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
              className: "text-5xl font-extrabold text-black ".concat((headerNav_module_default()).Heading),
              children: ["Build your", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* TypeAnimation */.e, {
                sequence: ["Tech", 5000, "Engineering", 5000, "Design", 5000, "Product", 5000, "Tech Support", 5000, "Data Science", 5000, "AI"],
                wrapper: "span",
                cursor: true,
                repeat: Infinity,
                className: "text-[#15808D]"
              }), "Team in", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "text-[#FA6262]",
                children: "7 days!"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: " w-[822px] pt-4 text-[20px] font-medium text-center leading-[27.28px] text-[#8B8C9C] ".concat((headerNav_module_default()).headingdesc),
              children: ["Streamline your hiring process with", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "font-semibold text-[#15808D]",
                children: "India's leading recruitment consultant"
              }), ", offering expert end-to-end recruitment solutions for quick and qualified tech talent hiring."]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mt-5 sm:mt-8 space-y-9 md:space-y-0 sm:flex sm:justify-center lg:justify-start ".concat((headerNav_module_default()).headingButton),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/demo",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    className: "bg-[#15808D] w-full flex items-center justify-center px-9 py-2 text-sm font-semibold rounded-full text-white",
                    children: "Hire Now"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "mt-2 md:mt-0 md:ml-5 ".concat((headerNav_module_default()).firstfoldbutton),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
                  channel: "youtube",
                  autoplay: true,
                  isOpen: isOpen,
                  videoId: "RCnFXG7vg70",
                  onClose: function onClose() {
                    return setOpen(false);
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                  type: "button",
                  className: "w-full cursor-pointer flex items-center justify-center rounded-full border px-9 py-2 text-sm font-semibold border-[#E2E8F0]",
                  onClick: function onClick() {
                    return setOpen(true);
                  },
                  "data-test-id": "watch-video",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                    width: "10",
                    height: "9",
                    viewBox: "0 0 10 9",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                      d: "M9.32708 5.41001L1.74408 8.85701C1.59177 8.92628 1.42452 8.95622 1.25764 8.9441C1.09077 8.93198 0.929598 8.87819 0.7889 8.78764C0.648202 8.69709 0.532472 8.57268 0.452312 8.42582C0.372152 8.27895 0.330124 8.11432 0.330078 7.94701V1.05301C0.330124 0.88569 0.372152 0.721059 0.452312 0.574194C0.532472 0.427329 0.648202 0.302924 0.7889 0.212376C0.929598 0.121828 1.09077 0.06803 1.25764 0.0559107C1.42452 0.0437913 1.59177 0.0737379 1.74408 0.143007L9.32708 3.59001C10.1091 3.94501 10.1091 5.05501 9.32708 5.41001Z",
                      fill: "#15808D"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "ml-2.5",
                    children: "Watch video"
                  })]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "pt-10",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "/home/dashboard.png",
                alt: "event-date",
                width: 1000,
                height: 1000,
                loading: "lazy"
              })
            })]
          })
        })
      })
    })
  });
};

/* harmony default export */ var commonlayout_HeaderNav = (HeaderNav);
// EXTERNAL MODULE: ./src/constants.js
var constants = __webpack_require__(10288);
// EXTERNAL MODULE: ./src/css/modules/hiringchallenges.module.scss
var hiringchallenges_module = __webpack_require__(62483);
var hiringchallenges_module_default = /*#__PURE__*/__webpack_require__.n(hiringchallenges_module);
;// CONCATENATED MODULE: ./src/components/home/HiringChallenges.js






var HiringChallenges = function HiringChallenges() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: "secondary-features",
      "aria-label": "Features for simplifying everyday business tasks",
      className: "font-sans mt-10 pt-20 sm:pt-32 pb-10 ".concat((hiringchallenges_module_default()).sectioncontainer),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-auto max-w-2xl flex flex-col items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-5xl font-bold text-slate-900 sm:text-4xl ".concat((hiringchallenges_module_default()).hiringtitles),
            children: "Why does Tacnique suit you better?"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mt-4 text-lg w-[586px] text-center leading-6 font-medium text-gray-500 ".concat((hiringchallenges_module_default()).hiringp),
            children: "At Tacnique, we pride ourselves on being more than just a recruitment consulting agency, we are your strategic partner in talent acquisition."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:mt-16 ".concat((hiringchallenges_module_default()).hiringcardscontainer),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4",
            role: "tablist",
            "aria-orientation": "horizontal",
            children: constants/* cloudHiring */.Nk === null || constants/* cloudHiring */.Nk === void 0 ? void 0 : constants/* cloudHiring.map */.Nk.map(function (value, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "transform transition duration-500 rounded-lg bg-[#F5FEFF] hover:shadow-lg p-5",
                "data-test-id": "cloud-".concat(index),
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-10 rounded-full bg-secondary-50 p-1.5",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: (value === null || value === void 0 ? void 0 : value.icon) || "/loading-placeholder.png",
                      alt: value === null || value === void 0 ? void 0 : value.icon,
                      width: 40,
                      height: 40,
                      loading: "lazy"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                    className: "text-[22px] font-semibold text-black",
                    "data-test-id": "cloud-".concat(index, "-title"),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "absolute inset-0"
                    }), value.title]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "mt-4 font-normal text-lg leading-6 text-[#4A5568]",
                    "data-test-id": "cloud-".concat(index, "-description"),
                    children: value.desc
                  })]
                })
              }, index);
            })
          })
        })]
      })
    })
  });
};

/* harmony default export */ var home_HiringChallenges = (HiringChallenges);
// EXTERNAL MODULE: ./src/components/home/BrandingLogos.js
var BrandingLogos = __webpack_require__(21305);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utilities.js
var utilities = __webpack_require__(66156);
// EXTERNAL MODULE: ./node_modules/typed.js/lib/typed.js
var lib_typed = __webpack_require__(13614);
var typed_default = /*#__PURE__*/__webpack_require__.n(lib_typed);
// EXTERNAL MODULE: ./src/data/staticContent.js
var staticContent = __webpack_require__(23701);
// EXTERNAL MODULE: ./src/components/home/Cloud/CloudComponents.js
var CloudComponents = __webpack_require__(32737);
;// CONCATENATED MODULE: ./src/components/commonlayout/HeaderNavEng.js







var HeaderNavEng = function HeaderNavEng() {
  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "relative bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "max-w-7xl mx-auto flex flex-col md:flex-row mt-20 md:mt-15 items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative z-10 pb-14 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
          className: "mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-24 lg:mt-20 lg:px-8 xl:mt-24",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "text-left",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
              className: "text-3xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: "block xl:inline",
                children: ["One", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "text-primary-600",
                  children: "Master Interview."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
                className: "hidden md:block"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: "block xl:inline",
                children: ["Endless", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "text-primary-600",
                  children: "Job Offers."
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-left mt-3 text-xl text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl md:mt-5 md:text-2xl lg:mx-0",
              children: "Upgrade your job hunt with our cloud-based hiring platform powered by AI for tailored recommendations for you."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mt-5 sm:mt-8 space-y-9 md:space-y-0 sm:flex sm:justify-center lg:justify-start",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/signup",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    target: "_self",
                    className: "w-full flex items-center justify-center px-8 py-3 text-xl font-medium rounded-full text-white bg-primary-600 hover:bg-primary-700 md:py-4 md:text-lg md:px-10",
                    "data-test-id": "get-started",
                    children: "Interview Now"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "mt-2 md:mt-0 md:ml-5",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
                  channel: "youtube",
                  autoplay: true,
                  isOpen: isOpen,
                  videoId: "QTJ2Jjzr7u4",
                  onClose: function onClose() {
                    return setOpen(false);
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                  type: "button",
                  className: "w-full cursor-pointer flex items-center justify-center rounded-full border px-8 py-3 md:py-3.5 text-xl font-medium border-primary-300 text-primary-600 hover:border-primary-400 active:bg-primary-100 active:text-primary-700",
                  onClick: function onClick() {
                    return setOpen(true);
                  },
                  "data-test-id": "watch-video",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    "aria-hidden": "true",
                    className: "h-6 w-6 flex-none",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
                      cx: "12",
                      cy: "12",
                      r: "11.5",
                      stroke: "#5CB0BA"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                      d: "M9.5 14.382V9.618a.5.5 0 0 1 .724-.447l4.764 2.382a.5.5 0 0 1 0 .894l-4.764 2.382a.5.5 0 0 1-.724-.447Z",
                      fill: "#5CB0BA",
                      stroke: "#5CB0BA"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "ml-2.5",
                    children: "Watch the video"
                  })]
                })]
              })]
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full md:w-1/2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full px-4 sm:px-6  md:w-full  mx-auto md:mr-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/home/hero-main-img-new.png",
            alt: "hero image",
            layout: "responsive",
            width: 500,
            height: 300,
            priority: true
          })
        })
      })]
    })
  });
};

/* harmony default export */ var commonlayout_HeaderNavEng = (HeaderNavEng);
// EXTERNAL MODULE: ./src/components/layouts/CImage.js
var CImage = __webpack_require__(79841);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./src/css/modules/stats.module.scss
var stats_module = __webpack_require__(42195);
var stats_module_default = /*#__PURE__*/__webpack_require__.n(stats_module);
;// CONCATENATED MODULE: ./src/components/home/Stats.js






var Stats = function Stats() {
  var _useState = (0,react.useState)(false),
      triggerCount = _useState[0],
      setTriggerCount = _useState[1];

  var stats = [{
    value: 1,
    label: "Profiles to choose from",
    suffix: "M+"
  }, {
    value: 10,
    label: "Successful Matches",
    suffix: "K+"
  }, {
    value: 50,
    label: "Insights per Candidate",
    suffix: "+"
  }, {
    value: 80,
    label: "Faster Hiring Process",
    suffix: "%"
  }, {
    value: 72,
    label: "Interview Turnaround",
    suffix: " Hrs"
  }, {
    value: 10,
    label: "Technical Skills Evaluated",
    suffix: "+"
  }];
  (0,react.useEffect)(function () {
    // Trigger the animation on every visit
    setTriggerCount(false);
    setTimeout(function () {
      setTriggerCount(true);
    }, 2000); // Small delay to reset animation cleanly
  }, []); // Triggers on every component mount

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "flex justify-center items-center font-sans bg-[#F2FBFC] py-20 ".concat((stats_module_default()).statsmaincontainer),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col items-center w-2/3 h-2/3 bg-[url('/home/world-map.svg')] bg-no-repeat bg-cover ".concat((stats_module_default()).statsdiv),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
        className: "w-[652px] text-5xl text-center font-bold text-black leading-[60.2px] ".concat((stats_module_default()).statsh1),
        children: ["Why is Tacnique the", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-[#15808D]",
          children: "Recruitment Leader in India"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-lg text-center leading-6 ".concat((stats_module_default()).statsp),
        children: "As a leading recruitment consulting agency, we offer tailored recruitment consulting services, Interview as a Service (IaaS), and BOT solutions, powered by our expertise and AI-driven evaluation methods to meet your specific hiring needs."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-20 w-full grid grid-cols-3 gap-6 text-center bg-cover bg-center ".concat((stats_module_default()).statscountmaincontainer),
        style: {
          backgroundImage: "url('/background-image.jpg')"
        },
        children: stats.map(function (stat, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "bg-transparent flex w-full",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full w-[2px] mr-3 bg-gradient-to-b from-[#15808D] to-[#FFFFFF]"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (stats_module_default()).statscountcontainer,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-5xl text-left font-extrabold text-gray-800 ".concat((stats_module_default()).statscount),
                children: triggerCount && /*#__PURE__*/(0,jsx_runtime.jsx)(build/* default */.ZP, {
                  start: 0,
                  end: stat.value,
                  duration: 2,
                  suffix: stat.suffix
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-[#8B8C9C] font-semibold text-lg mt-2 ".concat((stats_module_default()).statscountp),
                children: stat.label
              })]
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var home_Stats = (Stats);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/css/modules/whatWeOffer.module.scss
var whatWeOffer_module = __webpack_require__(89082);
var whatWeOffer_module_default = /*#__PURE__*/__webpack_require__.n(whatWeOffer_module);
// EXTERNAL MODULE: ./src/css/modules/offerDiscSection.module.scss
var offerDiscSection_module = __webpack_require__(58574);
var offerDiscSection_module_default = /*#__PURE__*/__webpack_require__.n(offerDiscSection_module);
;// CONCATENATED MODULE: ./src/components/home/OfferDiscSection.js





var OfferDiscSection = function OfferDiscSection(_ref) {
  var number = _ref.number,
      title = _ref.title,
      description = _ref.description,
      isActive = _ref.isActive;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((offerDiscSection_module_default()).OfferDisccontainer, " ").concat(isActive ? (offerDiscSection_module_default()).active : (offerDiscSection_module_default()).inactive),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "text-4xl font-extrabold ".concat((offerDiscSection_module_default()).OfferDiscnumber, " ").concat(isActive ? (offerDiscSection_module_default()).active : (offerDiscSection_module_default()).inactive),
      children: number
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "".concat((offerDiscSection_module_default()).offerdisch2, " ").concat(isActive ? (offerDiscSection_module_default()).active : (offerDiscSection_module_default()).inactive),
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (offerDiscSection_module_default()).offerdiscp,
      children: description
    })]
  });
};

/* harmony default export */ var home_OfferDiscSection = (OfferDiscSection);
;// CONCATENATED MODULE: ./src/components/home/WhatWeOffer.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var WhatWeOffer = function WhatWeOffer() {
  var _useState = (0,react.useState)(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var data = [{
    number: "01",
    title: "Recruitment Consulting",
    description: "With our end-to-end expert recruitment consulting, we identify the best-fit candidates for your business needs, giving you a curated shortlist to speed up your hiring and interview process.",
    image: "/Images/HomepageRevamp/group1.svg",
    alt: "group1"
  }, {
    number: "02",
    title: "Interview Outsourcing",
    description: "Found the right candidates, but short on time and tech expertise to interview them? Tacnique’s domain experts will interview your ideal candidates for you.",
    image: "/Images/HomepageRevamp/group2.svg",
    alt: "group2"
  }, {
    number: "03",
    title: "BOT Build, Operate, Transfer",
    description: "We build a team of tech experts, collaborate on your projects, and transfer the entire team to you on your mark.",
    image: "/Images/HomepageRevamp/group3.svg",
    alt: "group3"
  }];
  (0,react.useEffect)(function () {
    var interval = setInterval(function () {
      setActiveIndex(function (prevIndex) {
        return (prevIndex + 1) % data.length;
      });
    }, 5000); // Change slide every 5 seconds

    return function () {
      return clearInterval(interval);
    };
  }, [data.length]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "max-w-7xl mx-auto",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col items-center justify-center gap-6 pt-8 pb-16 px-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "text-5xl font-bold ".concat((whatWeOffer_module_default()).offerh1),
        children: "What We Offer?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: (whatWeOffer_module_default()).offerp,
        children: ["Tacnique excels as the", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "text-[#178F9D] font-bold",
          children: [" ", "fastest talent hiring agency", " "]
        }), " ", "in India offering tailored recruitment consulting, Interview as a Service (IaaS), and BOT solutions for Design, Engineering, and Product roles utilizing AI-driven evaluation methods to meet your specific hiring needs."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (whatWeOffer_module_default()).offerwrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (whatWeOffer_module_default()).leftcontainer,
        children: data.map(function (value, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return setActiveIndex(index);
            },
            className: "cursor-pointer ".concat(activeIndex === index ? (whatWeOffer_module_default()).active : ""),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(home_OfferDiscSection, _objectSpread(_objectSpread({}, value), {}, {
              isActive: activeIndex === index
            }))
          }, index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (whatWeOffer_module_default()).rightcontainer,
        children: data.map(function (item, index) {
          return activeIndex === index ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (whatWeOffer_module_default()).imageActive,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: 1000,
              height: 1000,
              src: item.image,
              alt: item.alt
            })
          }, index) : null;
        })
      })]
    })]
  });
};

/* harmony default export */ var home_WhatWeOffer = (WhatWeOffer);
// EXTERNAL MODULE: ./src/css/modules/helpBusiness.module.scss
var helpBusiness_module = __webpack_require__(67787);
var helpBusiness_module_default = /*#__PURE__*/__webpack_require__.n(helpBusiness_module);
;// CONCATENATED MODULE: ./src/components/home/HelpBusiness.js







var HelpBusiness = function HelpBusiness() {
  var carddata = [{
    image: '/Images/HomepageRevamp/HelpB/how_to_reg.png',
    alt: 'how_to_reg',
    title: 'Tailored Recruitment Strategies',
    description: 'We work on custom industry needs and offer end-to-end recruitment consulting, interview outsourcing, and BOT models that suit you.'
  }, {
    image: '/Images/HomepageRevamp/HelpB/groups.png',
    alt: 'groups',
    title: 'Extensive Pool of Talent',
    description: 'You can draw exceptional candidates from our database with 1 Million+ profiles of diverse skills and competencies for quick screening.'
  }, {
    image: '/Images/HomepageRevamp/HelpB/document_scanner.png',
    alt: 'document_scanner',
    title: 'In-depth Screening Process',
    description: 'The screening process for candidates includes in-depth interviewing, skill assessment, and background verification for enhanced experience.'
  }, {
    image: '/Images/HomepageRevamp/HelpB/currency_rupee_circle.png',
    alt: 'currency_rupee_circle',
    title: 'No Strings Attached Policy',
    description: 'We ensure you only pay when you hire the best talent successfully. There will be no charges if our suggestions do not align.'
  }, {
    image: '/Images/HomepageRevamp/HelpB/support_agent.png',
    alt: 'support_agent',
    title: 'Continuous Support and Consultation',
    description: 'We believe in long-term relationships with our clients and provide continuous support throughout the process, and feedback.'
  }, {
    image: '/Images/HomepageRevamp/HelpB/flowchart.png',
    alt: 'flowchart',
    title: 'Streamlined hiring process',
    description: 'Our structured interview processes are recorded and handled by our domain experts for transparency and accountability in hiring.'
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "pt-20 font-sans flex justify-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
        className: "w-7/12 font-bold text-5xl text-center ".concat((helpBusiness_module_default()).HelpBusinessHeading),
        children: ["How do We Help Businesses ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-[#15808D]",
          children: "Find the Right Talent?"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "text-lg text-center leading-6 mx-auto mt-4 ".concat((helpBusiness_module_default()).HelpBusiness),
      children: "Our approach as a top-notch recruitment consulting agency ensures that we help you identify the right candidates who possess the key skills required by your organisation."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "max-w-7xl ".concat((helpBusiness_module_default()).HelpCardscontainer),
      children: carddata.map(function (card, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (helpBusiness_module_default()).HelpCards,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            height: 34,
            width: 34,
            src: card.image,
            alt: card.alt,
            loading: "lazy"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: card.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: card.description
          })]
        });
      })
    })]
  });
};

/* harmony default export */ var home_HelpBusiness = (HelpBusiness);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./src/css/modules/testimonials.module.scss
var testimonials_module = __webpack_require__(15912);
var testimonials_module_default = /*#__PURE__*/__webpack_require__.n(testimonials_module);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var react_fontawesome_index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
;// CONCATENATED MODULE: ./src/components/home/Testimonials.js



function Testimonials_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Testimonials_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Testimonials_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Testimonials_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var Testimonials = function Testimonials() {
  var slickRef = react.useRef(null);

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeIndex = _React$useState2[0],
      setActiveIndex = _React$useState2[1];

  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000
  };
  var leftdata = [{
    name: "Arjun Mehta",
    post: "CEO of Innovatech Solutions, India",
    image: "/Images/HomepageRevamp/1.png",
    alt: "Arjun Mehta",
    description: "What I loved most about Tacnique was how quickly they took our feedback and made adjustments. They really made the whole recruitment process so much easier."
  }, {
    name: "Priya Kapoor",
    post: "CMO of GreenEarth Industries, India",
    image: "/Images/HomepageRevamp/2.png",
    alt: "Priya Kapoor",
    description: "Finding Indian talents became very easy with Tacnique! I was amazed by their constant support on onboarding of the candidates quickly!"
  }];
  var centerdata = [{
    name: "Michael Roberts",
    post: "COO of Stellar Innovations, USA",
    image: "/Images/HomepageRevamp/3.png",
    alt: "Michael Roberts",
    description: "I worked with the Tacnique team on the BOT model. They were extremely responsive and helpful in building a solid team, managing services, and smooth transfer."
  }, {
    name: "Emily Davis",
    post: "Chief HR Officer at NexaCorp, USA",
    image: "/Images/HomepageRevamp/4.png",
    alt: "Emily Davis",
    description: "My experience with Tacnique team was good! We wanted to build our team quickly without compromising on quality. Overall a very friendly, customer focused, very reliable service."
  }];
  var rightdata = [{
    name: "David Martinez",
    post: "HR Manager at Apex Innovations, USA",
    image: "/Images/HomepageRevamp/5.png",
    alt: "David Martinez",
    description: "I thank the Tacnique Team for extraordinary customer support across time zones and prompt results. I would hire them in the future, too!"
  }, {
    name: "John Anderson",
    post: "CEO of QuantumLeap Technologies, USA",
    image: "/Images/HomepageRevamp/6.png",
    alt: "John Anderson",
    description: "Tacnique’s services were incredible! Their expert panels made interviewing for multiple roles smooth, helping us hire top talent."
  }];
  var mergedData = [].concat(leftdata, centerdata, rightdata);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: " lg:bg-[url('/Images/HomepageRevamp/bgimg.png')] bg-no-repeat bg-cover font-sans mx-auto px-4 max-w-full mt-10  sm:pt-20 pb-10 ".concat((testimonials_module_default()).Testimonialcontainer),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mx-auto max-w-2xl flex flex-col items-center ",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "text-5xl font-bold text-slate-900 sm:text-4xl ".concat((testimonials_module_default()).Testimonialtitles),
        children: "Testimonials"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mt-4 text-lg w-[586px] text-center leading-6 font-medium text-gray-500 ".concat((testimonials_module_default()).Testimonialp),
        children: "We are committed to delivering service excellence which is reflected in your reviews."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "max-w-7xl mx-auto ".concat((testimonials_module_default()).cardsmaincontainer),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (testimonials_module_default()).cardscontainerdiv,
        children: leftdata.map(function (card, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "p-6 bg-white ".concat((testimonials_module_default()).singleCardContainer),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (testimonials_module_default()).descriptionp,
                  children: card.description
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between ".concat((testimonials_module_default()).namepostDiv),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (testimonials_module_default()).namep,
                    children: card.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (testimonials_module_default()).postp,
                    children: card.post
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  height: 50,
                  width: 50,
                  src: card.image,
                  alt: card.alt
                })]
              })]
            })
          });
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (testimonials_module_default()).cardscontainerdiv,
        children: centerdata.map(function (card, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "p-6 bg-white ".concat((testimonials_module_default()).singleCardContainer),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (testimonials_module_default()).descriptionp,
                  children: card.description
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between ".concat((testimonials_module_default()).namepostDiv),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (testimonials_module_default()).namep,
                    children: card.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (testimonials_module_default()).postp,
                    children: card.post
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  height: 50,
                  width: 50,
                  src: card.image,
                  alt: card.alt
                })]
              })]
            })
          });
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (testimonials_module_default()).cardscontainerdiv,
        children: rightdata.map(function (card, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "p-6 bg-white ".concat((testimonials_module_default()).singleCardContainer),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (testimonials_module_default()).descriptionp,
                  children: card.description
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between ".concat((testimonials_module_default()).namepostDiv),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (testimonials_module_default()).namep,
                    children: card.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: (testimonials_module_default()).postp,
                    children: card.post
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  height: 50,
                  width: 50,
                  src: card.image,
                  alt: card.alt
                })]
              })]
            })
          });
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (testimonials_module_default()).mobilecardscontainerdiv,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((testimonials_module_default()).mobilecardscontainer, " "),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, Testimonials_objectSpread(Testimonials_objectSpread({}, settings), {}, {
          ref: slickRef,
          afterChange: function afterChange(index) {
            return setActiveIndex(index);
          },
          children: mergedData.map(function (item, index) {
            var description = item.description,
                image = item.image,
                alt = item.alt,
                name = item.name,
                post = item.post;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "".concat((testimonials_module_default()).mobilecardwrapper),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "".concat((testimonials_module_default()).mobilecarddesc, " bg-[url('/Images/HomepageRevamp/svg.png')] bg-no-repeat "),
                  children: description
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "pt-6 mt-5 pb-0 mb-0 ".concat((testimonials_module_default()).mobiletestimonialcardnpi),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "".concat((testimonials_module_default()).mobilecardname),
                    children: name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "".concat((testimonials_module_default()).mobilecardpost),
                    children: post
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  height: 44,
                  width: 44,
                  src: image,
                  alt: alt
                })]
              })]
            });
          })
        })), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((testimonials_module_default()).mobilecardsarrowdiv),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "".concat((testimonials_module_default()).mobilecardprevarrow),
            onClick: function onClick() {
              return slickRef.current.slickPrev();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
              icon: free_solid_svg_icons/* faChevronLeft */.A35
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "".concat((testimonials_module_default()).mobilecardprevarrow),
            onClick: function onClick() {
              return slickRef.current.slickNext();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_fontawesome_index_es/* FontAwesomeIcon */.G, {
              icon: free_solid_svg_icons/* faChevronRight */._tD
            })
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var home_Testimonials = (Testimonials);
;// CONCATENATED MODULE: ./src/components/home/Home.js



















var Header = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5522), __webpack_require__.e(5615), __webpack_require__.e(9851), __webpack_require__.e(2242), __webpack_require__.e(187)]).then(__webpack_require__.bind(__webpack_require__, 89781));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(89781)];
    }
  }
});
var Contact = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9869).then(__webpack_require__.bind(__webpack_require__, 31866));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(31866)];
    }
  }
});

var RedundantHeroImg = function RedundantHeroImg() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-[500px] max-w-[70vw] relative min-h-[500px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CImage/* default */.Z, {
      height: "325",
      width: "325",
      src: "/home/insight-ellipse.svg",
      alt: "insights-ellipse",
      className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full",
      loading: "lazy"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CImage/* default */.Z, {
      height: "406",
      width: "540",
      src: "/home/redundant_info.png",
      alt: "redundant_info",
      className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full",
      loading: "lazy"
    })]
  });
};

var HiringInfo = function HiringInfo() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-[500px] max-w-[70vw] relative min-h-[500px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CImage/* default */.Z, {
      height: "325",
      width: "325",
      src: "/home/insight-ellipse.svg",
      alt: "insights-ellipse",
      className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-[70vw]",
      loading: "lazy"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CImage/* default */.Z, {
      height: "117",
      width: "85",
      src: "/home/insight-ellipse-2.svg",
      alt: "insight-ellipse2",
      className: "absolute top-1/2 left-1/2 translate-x-[75%] -translate-y-[170%] ",
      loading: "lazy"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CImage/* default */.Z, {
      height: "484",
      width: "780",
      src: "/home/hiring_info.png",
      alt: "hiring_info",
      className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full scale-150 ",
      loading: "lazy"
    })]
  });
};

var Home = function Home(props) {
  var isEngineer = props.page === "engineers";
  var router = (0,next_router.useRouter)();
  var faqs = staticContent/* staticContent.faqs.candidate */.e.faqs.candidate;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [(0,utilities/* getHeader */.Pg)(router.pathname), /*#__PURE__*/(0,jsx_runtime.jsx)(Header, {
      isEngineer: isEngineer
    }), isEngineer ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(commonlayout_HeaderNavEng, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(BrandingLogos/* default */.Z, {
        isEngineer: isEngineer,
        heading: "Top tech companies who trust us",
        footing: "The tech elite relies on our unmatched interview assessment to scale their company."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CloudComponents/* InfoSectionFeatures */.Nt, {
        infoSections: infoSections
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
        className: "bg-ellipse py-4 pb-20 md:-mb-24",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CloudComponents/* FAQSectionText */.aB, {
            isEngineer: isEngineer,
            description: "Find speedy and trustworthy solutions to your queries about our cutting-edge cloud-based interview platform, virtual interview questions, engineering interview, and more."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CloudComponents/* FAQAccordion */.b7, {
            items: faqs
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-[url(\"/home/ellipse36.svg\")] bg-no-repeat bg-cover",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CloudComponents/* ReviewSection */.gI, {
            heading: "Tasting success with Tacnique",
            description: "Hear from real engineers who have landed their dream job with Tacnique's game-changing cloud interview platform."
          })
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(commonlayout_HeaderNav, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(home_WhatWeOffer, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(home_Stats, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(home_HelpBusiness, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(home_HiringChallenges, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(home_Testimonials, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-[url(\"/home/ellipse36.svg\")] bg-no-repeat bg-cover",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Contact, {})
    })]
  });
};

var infoSections = [{
  title: "No More Redundant \n Interviews",
  description: "Job hunting as a software engineer can be grueling: 10-15 applications a week, 8-10 hours on paperwork, and more time preparing for interviews. It's time to make your dream career a reality.",
  heroImg: "/home/redundant_img.png"
}, {
  title: "One Hiring Platform \n Multiple Offers",
  description: "Experience the future of tech hiring as Tacnique revolutionizes the job hunt for job seekers. No more endless scrolling, just personalized job offers based on your profile.",
  hero: HiringInfo
}, {
  title: "Land Your \n Dream Job",
  description: "We quantify your profile based on your skills. Our hiring solution saves time by repurposing your interview and suggesting opportunities suited to your strengths.",
  hero: RedundantHeroImg
}];
var items = [{
  title: "What are the primary parameters you use to evaluate a candidate?",
  description: "At Tacnique, we've developed a cutting-edge candidate evaluation process that leaves no stone unturned. Our comprehensive approach entails deep diving into key insights from our rigorous tech interview. We meticulously evaluate various factors such as behavioral competencies, knowledge competencies, and coding & problem-solving skills. Each section is further elaborated into 30+ insights to ensure you select only the best candidate for your team."
}, {
  title: "What is the interview process and format?",
  description: "The interview process is a carefully crafted and thought-out affair that aims to uncover the best talent in the tech industry. The format is split into three parts, each designed to test your skills and expertise in different areas. \n \n \n" + "".concat(String.fromCharCode(8226), " The introduction section, which lasts for 5 minutes, allows you to showcase your personality and communication skills. This gives technical interviewers an insight into how well you can collaborate and work in a team. \n \n") + "".concat(String.fromCharCode(8226), " The project discussion section, which lasts for 10 minutes, focuses on your ability to understand complex project requirements and develop innovative solutions. \n \n") + "".concat(String.fromCharCode(8226), " The coding and problem-solving section, which lasts for 30 minutes, is where you will be asked to demonstrate your technical abilities. You will be given a series of coding challenges and problems to solve. \n \n") + "".concat(String.fromCharCode(8226), " The wrap-up section lasts for 15 minutes, where you can ask any questions you may have and wrap up the interview. However, if you are an associate software engineer or junior QA engineer, the wrap-up will only last 5 minutes. \n \n")
}, {
  title: "Which are the top tech companies you partner with, and the positions are they currently hiring for?",
  description: "We work with an impressive array of renowned companies that span diverse industries, from real estate and finance to healthcare and technology. Some of our esteemed clients include VTS, Zamp Finance, Medikabazaar, Solutelabs, Visa, Medicine Patent Pool, Alhabtoor, Zillow, JLL, and many more. \n \n " + "These companies seek talented software engineering and coding professionals for various positions requiring expertise in cutting-edge web technologies, such as Javascript, Python, Ruby, and more. Additionally, our clients seek individuals proficient in cloud technologies like AWS, GCP, Azure, and other industry-leading platforms."
}, {
  title: "Can I see the interviewer's profile?",
  description: "Our experienced technical interviewers conduct thorough and unbiased assessments of your skills. To ensure complete transparency, we offer access to the interviewer's profile, including their name, skills, number of interviews conducted, rating, and other relevant information. This information is accessible in the interview evaluation report, providing a comprehensive understanding of the interviewer's qualifications."
}];
var HeroSection = function HeroSection(_ref) {
  var title = _ref.title,
      description = _ref.description,
      hero = _ref.hero,
      titleHeadings = _ref.titleHeadings,
      titleSecondary = _ref.titleSecondary;
  var el = (0,react.useRef)(null);
  var typed = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (el.current) {
      var options = {
        strings: titleHeadings,
        typeSpeed: 50,
        backSpeed: 50,
        loop: true
      };
      typed.current = new (typed_default())(el.current, options);
      return function () {
        return typed.current.destroy();
      };
    }
  }, [el]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "py-10 pb-0 mt-16",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full md:w-1/2 flex flex-col items-center md:items-start space-y-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "w-full px-4 md:px-16 md:-mr-12 pr-0 mx-auto md:ml-auto space-y-8",
          children: [titleHeadings ? /*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
            className: "text-3xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-5xl capitalize",
            children: [titleSecondary, /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex text-primary-600",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "text-3xl tracking-tight font-extrabold  sm:text-5xl md:text-5xl",
                style: {
                  whiteSpace: "pre"
                },
                ref: el
              })
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: "text-3xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-5xl",
            dangerouslySetInnerHTML: {
              __html: title
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-left mt-3 text-xl text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl md:mt-5 md:text-2xl lg:mx-0",
            children: description
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full md:w-1/2 pt-10",
        children: hero
      })]
    })
  });
};
/* harmony default export */ var home_Home = (Home);

/***/ }),

/***/ 79841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CImage = function CImage(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: "next-image ".concat(props.className || ""),
    style: props.style || {},
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "relative w-full h-full",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread(_objectSpread({}, props), {}, {
        className: "absolute top-0 left-0 w-full h-full ".concat(props.imgclassname || "")
      }))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CImage);

/***/ }),

/***/ 23701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ staticContent; }
/* harmony export */ });
// Static content to replace Contentful CMS
var staticContent = {
  // Why Tacnique section content
  whyTacnique: {
    whyTacniqueHeader: "Why Tacnique",
    whyTacniqueDescription: "The most extensive part of the recruitment process is the time. Tacnique helps you solve such bottlenecks by accomplishing higher results in shorter periods of time."
  },
  // Why Tacnique list items (for the circular layout)
  whyTacniqueList: [{
    title: "Save Time",
    containerClass: "point deg0",
    innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
    imageLeft: false,
    icon: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/save-time.svg"
        }
      }
    },
    testId: "why-save-time"
  }, {
    title: "Reduce Cost",
    containerClass: "point deg60",
    innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
    imageLeft: true,
    icon: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/reduce-cost.svg"
        }
      }
    },
    testId: "why-reduce-cost"
  }, {
    title: "Quality Hire",
    containerClass: "point deg120",
    innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
    imageLeft: false,
    icon: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/quality-hire.svg"
        }
      }
    },
    testId: "why-quality-hire"
  }, {
    title: "Scale Teams",
    containerClass: "point deg180",
    innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
    imageLeft: true,
    icon: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/scale-teams.svg"
        }
      }
    },
    testId: "why-scale-teams"
  }, {
    title: "Data Driven",
    containerClass: "point deg240",
    innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
    imageLeft: false,
    icon: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/data-driven.svg"
        }
      }
    },
    testId: "why-data-driven"
  }, {
    title: "Better Experience",
    containerClass: "point deg300",
    innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
    imageLeft: true,
    icon: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/better-experience.svg"
        }
      }
    },
    testId: "why-better-experience"
  }],
  // Client testimonials
  clientTestimonials: [{
    userName: "Krishna Pandya",
    userDesignation: "Associate People Manager",
    review: "We were really impressed with the recorded Interview and their detailed assessment which really helps us to make the hiring decision very fast. By scheduling Interviews with Tacnique, we are also saving our tech team valuable time.",
    desc: "",
    companyLogo: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/solutelabslogo.png"
        }
      }
    },
    userPhoto: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/krishna.png"
        }
      }
    }
  }],
  // Candidate reviews
  candidateReviews: [{
    name: "Sumit S",
    ratings: "5",
    description: "The interview was challenging and interesting. It's highly engaging.",
    userImage: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/profile.svg"
        }
      }
    }
  }, {
    name: "Priyanka C",
    ratings: "5",
    description: "This was the first time that the interviewer made things so clear and explained everything. Thanks Tacnique.",
    userImage: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/profile.svg"
        }
      }
    }
  }, {
    name: "Ankita R",
    ratings: "4",
    description: "It was a great interview session. The process was easy and smooth.",
    userImage: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/profile.svg"
        }
      }
    }
  }, {
    name: "Arnab D",
    ratings: "5",
    description: "Really liked it and learnt a lot. Highly recommended.",
    userImage: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/profile.svg"
        }
      }
    }
  }, {
    name: "Seema S",
    ratings: "4",
    description: "Good experience to have such wonderful discussion and getting instant feedbacks.",
    userImage: {
      fields: {
        file: {
          url: "//images.ctfassets.net/placeholder/profile.svg"
        }
      }
    }
  }],
  // FAQs for candidates
  faqs: {
    candidate: [{
      title: "What are the primary parameters you use to evaluate a candidate?",
      description: "At Tacnique, we've developed a cutting-edge candidate evaluation process that leaves no stone unturned. Our comprehensive approach entails deep diving into key insights from our rigorous tech interview. We meticulously evaluate various factors such as behavioral competencies, knowledge competencies, and coding & problem-solving skills. Each section is further elaborated into 30+ insights to ensure you select only the best candidate for your team."
    }, {
      title: "What is the interview process and format?",
      description: "The interview process is a carefully crafted and thought-out affair that aims to uncover the best talent in the tech industry. The format is split into three parts, each designed to test your skills and expertise in different areas. \n \n \n• The introduction section, which lasts for 5 minutes, allows you to showcase your personality and communication skills. This gives technical interviewers an insight into how well you can collaborate and work in a team. \n \n• The project discussion section, which lasts for 10 minutes, focuses on your ability to understand complex project requirements and develop innovative solutions. \n \n• The coding and problem-solving section, which lasts for 30 minutes, is where you will be asked to demonstrate your technical abilities. You will be given a series of coding challenges and problems to solve. \n \n• The wrap-up section lasts for 15 minutes, where you can ask any questions you may have and wrap up the interview. However, if you are an associate software engineer or junior QA engineer, the wrap-up will only last 5 minutes. \n \n"
    }, {
      title: "Which are the top tech companies you partner with, and the positions are they currently hiring for?",
      description: "We work with an impressive array of renowned companies that span diverse industries, from real estate and finance to healthcare and technology. Some of our esteemed clients include VTS, Zamp Finance, Medikabazaar, Solutelabs, Visa, Medicine Patent Pool, Alhabtoor, Zillow, JLL, and many more. \n \n These companies seek talented software engineering and coding professionals for various positions requiring expertise in cutting-edge web technologies, such as Javascript, Python, Ruby, and more. Additionally, our clients seek individuals proficient in cloud technologies like AWS, GCP, Azure, and other industry-leading platforms."
    }, {
      title: "Can I see the interviewer's profile?",
      description: "Our experienced technical interviewers conduct thorough and unbiased assessments of your skills. To ensure complete transparency, we offer access to the interviewer's profile, including their name, skills, number of interviews conducted, rating, and other relevant information. This information is accessible in the interview evaluation report, providing a comprehensive understanding of the interviewer's qualifications."
    }]
  },
  // Blog content (empty for now, can be populated if needed)
  blog: {
    fields: {
      blog: null
    }
  }
};

/***/ }),

/***/ 18556:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Heading":"headerNav_Heading__RBMqJ","headingdesc":"headerNav_headingdesc__Icb6L","headingButton":"headerNav_headingButton__7kqIZ","firstfoldbutton":"headerNav_firstfoldbutton__ge0Zo"};

/***/ }),

/***/ 67787:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HelpBusiness":"helpBusiness_HelpBusiness__rmMiI","HelpBusinessHeading":"helpBusiness_HelpBusinessHeading__Imqza","HelpCardscontainer":"helpBusiness_HelpCardscontainer__lZsd6","HelpCards":"helpBusiness_HelpCards__3zfOh"};

/***/ }),

/***/ 62483:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hiringtitles":"hiringchallenges_hiringtitles__PUbpz","sectioncontainer":"hiringchallenges_sectioncontainer__hAOI_","hiringp":"hiringchallenges_hiringp__3ic6F","hiringcardscontainer":"hiringchallenges_hiringcardscontainer__AHp_0"};

/***/ }),

/***/ 58574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"OfferDisccontainer":"offerDiscSection_OfferDisccontainer__DuCvw","active":"offerDiscSection_active__A74Oo","inactive":"offerDiscSection_inactive__nxL_Q","OfferDiscnumber":"offerDiscSection_OfferDiscnumber__0GLK9","offerdisch2":"offerDiscSection_offerdisch2__Rf8Gr","offerdiscp":"offerDiscSection_offerdiscp__tNEfx"};

/***/ }),

/***/ 42195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"statsh1":"stats_statsh1__TU__k","statsdiv":"stats_statsdiv__1Kb0I","statsp":"stats_statsp__2Kwhq","statscount":"stats_statscount__TLdZW","statscountp":"stats_statscountp__0acjP","statscountcontainer":"stats_statscountcontainer__Q6cC8","statscountmaincontainer":"stats_statscountmaincontainer__hncDI","statsmaincontainer":"stats_statsmaincontainer___kz3A"};

/***/ }),

/***/ 15912:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Testimonialcontainer":"testimonials_Testimonialcontainer__PWrLo","Testimonialtitles":"testimonials_Testimonialtitles__ydGjR","Testimonialp":"testimonials_Testimonialp__TEJMN","cardsmaincontainer":"testimonials_cardsmaincontainer__TGac0","cardscontainerdiv":"testimonials_cardscontainerdiv__eDeet","singleCardContainer":"testimonials_singleCardContainer__0SKrq","descriptionp":"testimonials_descriptionp__fzKlO","namep":"testimonials_namep__rXlMP","postp":"testimonials_postp__RjXdQ","namepostDiv":"testimonials_namepostDiv___rOm_","mobilecardscontainerdiv":"testimonials_mobilecardscontainerdiv__tojHm","mobiletestimonialcardnpi":"testimonials_mobiletestimonialcardnpi__JbPpV","mobilecardscontainer":"testimonials_mobilecardscontainer__MCN5T","mobilecardwrapper":"testimonials_mobilecardwrapper__BbMiH","mobilecarddesc":"testimonials_mobilecarddesc__QvHQN","mobilecardname":"testimonials_mobilecardname__FUas0","mobilecardpost":"testimonials_mobilecardpost__ZXbsc","mobilecardprevarrow":"testimonials_mobilecardprevarrow__us55q","mobilecardsarrowdiv":"testimonials_mobilecardsarrowdiv__HIqzv"};

/***/ }),

/***/ 89082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offerp":"whatWeOffer_offerp__W7vBl","offerwrapper":"whatWeOffer_offerwrapper__pm6Gy","offerh1":"whatWeOffer_offerh1__Qj_Us","leftcontainer":"whatWeOffer_leftcontainer__ci7jC","rightcontainer":"whatWeOffer_rightcontainer__tiUF1","imageActive":"whatWeOffer_imageActive__G4R8d","imageInactive":"whatWeOffer_imageInactive__pLkzM"};

/***/ })

}]);